import { api } from './client'

const securityService = {
  // Spec 163: { data: { isAdmin: true } } for a Centerbase administrator; everyone
  // else gets cb-api's 403 `not-admin` (or 503 if CB could not answer; a dead CB
  // session is a 401, which client.js's interceptor turns into refresh / re-login).
  getAccess: () => api.get('/security/access'),
  getProfiles: () => api.get('/security/profiles'),
  getProfile: (id) => api.get(`/security/profiles/${id}`),
  deleteProfile: (id) => api.delete(`/security/profiles/${id}`),

  getPermissions: () => api.get('/security/permissions'),
  getUserPermissions: (userId) => api.get(`/security/permissions/${userId}`),

  getSecurityGrid: ({ userId, profileId } = {}) =>
    api.get('/security/grid', { userId, profileId }),

  getObjectSecurity: (objectId, objectType) =>
    api.get(`/security/object/${objectId}`, { objectType }),

  getRoles: () => api.get('/security/roles'),
  getGroups: () => api.get('/security/groups'),
}

export default securityService
